import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Label } from '@sopranodesign/pulse-components';
import { TemplatingTextInput } from '@sopranodesign/pulse-templating';

const ClickToVoiceCallContent = ({ content, onChange }) => {
  const handleConnectionIdChange = connectionId => {
    onChange({ ...content, connectionId });
  };

  const handleSourcePhoneNumberChange = sourcePhoneNumber => {
    onChange({ ...content, sourcePhoneNumber });
  };

  const handleDestinationPhoneNumberChange = destinationPhoneNumber => {
    onChange({ ...content, destinationPhoneNumber });
  };

  return (
    <Flex col fat="true" gap="sm">
      <Flex col fat>
        <Label>Connection ID*</Label>
        <TemplatingTextInput
          aria-label="Connection ID"
          placeholder="Connection ID"
          value={content.connectionId}
          onChange={handleConnectionIdChange}
        />
      </Flex>
      <Flex col fat>
        <Label>Source Phone Number*</Label>
        <TemplatingTextInput
          aria-label="Source Phone Number"
          placeholder="Source Phone Number"
          value={content.sourcePhoneNumber}
          onChange={handleSourcePhoneNumberChange}
        />
      </Flex>
      <Flex col fat>
        <Label>Destination Phone Number*</Label>
        <TemplatingTextInput
          aria-label="Destination Phone Number"
          placeholder="Destination Phone Number"
          value={content.destinationPhoneNumber}
          onChange={handleDestinationPhoneNumberChange}
        />
      </Flex>
    </Flex>
  );
};

ClickToVoiceCallContent.propTypes = {
  onChange: PropTypes.func.isRequired,
  content: PropTypes.shape({
    connectionId: PropTypes.string.isRequired,
    sourcePhoneNumber: PropTypes.string.isRequired,
    destinationPhoneNumber: PropTypes.string.isRequired
  }).isRequired
};

export default ClickToVoiceCallContent;
